module.exports = __webpack_public_path__ + "img/El Salvador.f714bd3f.svg";